import { render, staticRenderFns } from "./PcRedpackRain.vue?vue&type=template&id=0bea6947&"
import script from "./PcRedpackRain.vue?vue&type=script&lang=js&"
export * from "./PcRedpackRain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports